import { TypedEmitter } from 'tiny-typed-emitter'

interface StyleChangedEvents {
    changed: (data: string) => void
}

class StyleChangedEventEmitterClass extends TypedEmitter<StyleChangedEvents> {
    changed(data: string) {
        this.emit('changed', data)
    }
}

export const StyleChangedEventEmitter = new StyleChangedEventEmitterClass()
